module.exports = __webpack_public_path__ + "static/media/Energetic.1f62595a.png";